import Sel from '@/shared/view/CssSelectors'

import './styles.scss'

export default {
    ...Sel,
    flatCard: 'HKLrkZ-flat-card',
    totalCardFabricantes: 'HKLrkZ-total-card-fabricantes',

    // Matrix
    matrixContainer: 'HKLrkZ-matrix-container',
    matrixGrid: 'HKLrkZ-matrix-grid',
    matrixVerticalTextHeader: 'HKLrkZ-vertical-text',
    matrixCornerHeader: 'HKLrkZ-corner-header',
    matrixCellMedBadge: 'HKLrkZ-med-badge',
    matrixMedMissing: 'HKLrkZ-med-missing'
}